import { render, staticRenderFns } from "./GiteaOpenModal.vue?vue&type=template&id=9717bf6a&"
import script from "./GiteaOpenModal.vue?vue&type=script&lang=js&"
export * from "./GiteaOpenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteaOpenModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteaOpenModal.vue
// module id = 2352
// module chunks = 1